module.exports = __webpack_public_path__ + "img/helpbox-1.3851d434.png";